<lumiron-nav [brand]="'LUMIRON'" [navItems]="navItems"></lumiron-nav>

<div id="content-wrapper">
  <router-outlet></router-outlet>

  <lumiron-toasts></lumiron-toasts>

  <lumiron-footer></lumiron-footer>
</div>
